export var MosAppRoutes = ['M365Apps', 'Chat'];
//# sourceMappingURL=MosAppRoutes.js.map